module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.loading && _vm.hotel) ? _c('modal', {
    attrs: {
      "name": "settings",
      "width": _vm.modal.width,
      "minWidth": 360,
      "maxWidth": 1040,
      "height": _vm.modal.height,
      "adaptive": true,
      "scrollable": ""
    }
  }, [_c('div', {
    staticClass: "grid edit settings w100"
  }, [(!_vm.addbeachitem) ? _c('div', {
    staticClass: "grid data h50"
  }, [_c('h1', [_vm._v(_vm._s(_vm.hotel.name))]), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "Nome Hotel"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.hotel.name),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "name", $$v)
      },
      expression: "hotel.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid",
    staticStyle: {
      "grid-auto-flow": "column"
    }
  }, [_c('span', {
    staticClass: "grid colorpicker",
    staticStyle: {
      "grid-auto-flow": "column"
    }
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v("Colore Hotel")]), _vm._v(" "), _c('el-color-picker', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.hotel.colors.primary),
      callback: function($$v) {
        _vm.$set(_vm.hotel.colors, "primary", $$v)
      },
      expression: "hotel.colors.primary"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer xs"
  }), _vm._v(" "), _c('div', {
    staticClass: "grid settings"
  }, [_c('span', [_vm._v("Numero camera")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#00B325"
    },
    model: {
      value: (_vm.hotel.poolsettings.room),
      callback: function($$v) {
        _vm.$set(_vm.hotel.poolsettings, "room", $$v)
      },
      expression: "hotel.poolsettings.room"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Nome ospite")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#00B325"
    },
    model: {
      value: (_vm.hotel.poolsettings.guest),
      callback: function($$v) {
        _vm.$set(_vm.hotel.poolsettings, "guest", $$v)
      },
      expression: "hotel.poolsettings.guest"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Oggetti spiaggia")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#00B325"
    },
    model: {
      value: (_vm.hotel.poolsettings.chairs),
      callback: function($$v) {
        _vm.$set(_vm.hotel.poolsettings, "chairs", $$v)
      },
      expression: "hotel.poolsettings.chairs"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Arrivo e Partenza")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#00B325"
    },
    model: {
      value: (_vm.hotel.poolsettings.arrival),
      callback: function($$v) {
        _vm.$set(_vm.hotel.poolsettings, "arrival", $$v)
      },
      expression: "hotel.poolsettings.arrival"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Booking Ombrellone singolo giorno")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#00B325"
    },
    model: {
      value: (_vm.hotel.singledaybooking),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "singledaybooking", $$v)
      },
      expression: "hotel.singledaybooking"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-green block",
    on: {
      "click": _vm.updatehotel
    }
  }, [_vm._v("Salva Impostazioni")]), _vm._v(" "), _c('div', {
    staticClass: " spacer md"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.addbeachitem) ? _c('div', {
    staticClass: "addbeachitem"
  }, [_c('h3', [_vm._v("Aggiungi oggetto in spiaggia")]), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "Nome oggetto in spiaggia"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Nome oggetto spiaggia"
    },
    model: {
      value: (_vm.beachitem.name),
      callback: function($$v) {
        _vm.$set(_vm.beachitem, "name", $$v)
      },
      expression: "beachitem.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-radio', {
    attrs: {
      "label": "grid",
      "border": ""
    },
    model: {
      value: (_vm.beachitem.icon),
      callback: function($$v) {
        _vm.$set(_vm.beachitem, "icon", $$v)
      },
      expression: "beachitem.icon"
    }
  }, [_c('i', {
    staticClass: "far fa-grin-tongue-wink"
  })])], 1), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-green",
    on: {
      "click": _vm.updatebeachitems
    }
  }, [_vm._v("Aggiungi oggetto")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid seats h50",
    class: {
      neutral: _vm.passForm
    },
    style: ({
      background: _vm.hotel.colors.primary
    })
  }, [_vm._l((_vm.hotel.items), function(item, index) {
    return (!_vm.passForm) ? _c('div', {
      staticClass: "grid"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    }), _vm._v(" "), (!_vm.addbeachitem) ? _c('span', [_c('a', {
      on: {
        "click": function($event) {
          item.num -= 1
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-minus-square"
    })]), _vm._v(_vm._s(item.num)), _c('a', {
      on: {
        "click": function($event) {
          item.num += 1
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-plus-square"
    })])]) : _vm._e(), _vm._v(" "), (_vm.addbeachitem) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.deletebeachitem(index)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-trash"
    })]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.passForm) ? _c('div', {
    staticClass: "grid"
  }, [_c('el-form', {
    ref: "changepassForm",
    attrs: {
      "model": _vm.formel,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Inserisci la tua nuova password",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "show-password": "",
      "placeholder": "Password",
      "prefix-icon": "fas fa-key",
      "name": "password"
    },
    model: {
      value: (_vm.formel.password),
      callback: function($$v) {
        _vm.$set(_vm.formel, "password", $$v)
      },
      expression: "formel.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer xs"
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btn btn-green block",
    on: {
      "click": function($event) {
        return _vm.changepassword('changepassForm')
      }
    }
  }, [_vm._v("salva password")])], 1)], 1)], 1) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "grid navi",
    class: {
      neutral: _vm.passForm
    },
    style: ({
      background: _vm.hotel.colors.primary
    })
  }, [_c('div', {
    staticClass: "grid shader"
  }, [_c('div', {
    staticClass: "options"
  }, [(_vm.hotel.beachtype == 'grid') ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Cambia impostazioni spiaggia",
      "placement": "left-start"
    }
  }, [_c('el-button', [_c('router-link', {
    attrs: {
      "to": {
        path: '/editgrid/' + _vm.hotel._id
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-th"
  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Imposta pagamenti",
      "placement": "left-start"
    }
  }, [_c('el-button', [_c('router-link', {
    attrs: {
      "to": {
        path: '/pagamenti/' + _vm.hotel._id
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-cash-register"
  })])], 1)], 1), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Cambia la tua password",
      "placement": "left-start"
    }
  }, [_c('el-button', [_c('i', {
    staticClass: "fas fa-lock",
    on: {
      "click": function($event) {
        _vm.passForm = true
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "placement": "left-start"
    }
  }, [_c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Cancella " + _vm._s(_vm.hotel.name))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-trash"
  })])], 1)], 1)])])])]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Attenzione",
      "visible": _vm.dialogVisible,
      "width": "25%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('p', [_vm._v("Sei sicuro di voler cancellare " + _vm._s(_vm.hotel.name) + "?")]), _vm._v(" "), _c('p', [_vm._v("Tutti i dati verranno cancellati.")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("Anulla")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.deleteHotel
    }
  }, [_vm._v("Cancella")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ac7392c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings.vue
// module id = 628
// module chunks = 1